import { render, staticRenderFns } from "./TreeBranchIcon.vue?vue&type=template&id=d35e4ebe"
import script from "./TreeBranchIcon.vue?vue&type=script&lang=js"
export * from "./TreeBranchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports